import {
  type OpTableRawColumnType,
  type OpTableRecordType,
  type TableState,
} from '../OpTableCore/types';

export const opTablePersistedUiVersion = 3;

export interface OpTableCorePersistedState<
  RecordType extends OpTableRecordType = OpTableRecordType,
> {
  version: number;
  columns: OpTableRawColumnType<RecordType>[];
  filters: TableState<RecordType>['filters'];
  sorter: TableState<RecordType>['sorter'];
}

export const getStateToPersist = <RecordType extends OpTableRecordType>(
  tableState: Pick<TableState<RecordType>, 'columns' | 'filters' | 'sorter'>,
) => {
  return {
    version: opTablePersistedUiVersion,
    columns: tableState.columns,
    filters: tableState.filters,
    sorter: tableState.sorter,
  } as OpTableCorePersistedState<RecordType>;
};
